const sliders = [
    { id: 'products-1', heading: 'homepage-products-heading-1' },
    { id: 'products-2', heading: 'homepage-products-heading-2' },
];

sliders.forEach(function (slider) {
    $('#' + slider.id).slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        infinite: false,

        appendArrows: $('.' + slider.heading),

        prevArrow: '<button class="slick-prev">←</button>',
        nextArrow: '<button class="slick-next">→</button>',

        responsive: [
            { breakpoint: 1199, settings: { slidesToShow: 3 } },
            { breakpoint: 991, settings: { slidesToShow: 2 } },
            { breakpoint: 767, settings: { slidesToShow: 2 } },
            { breakpoint: 550, settings: { slidesToShow: 1 } },
        ]
    });
});
